export default {
  // baseURL: 'http://ticket-api.hzqykeji.com',
  version: '1.0.1',
  qiniu: {
    // 七牛空间绑定的访问域名（含协议）
    bucketDomain: 'https://sport-cdn.qietongvip.com',
    // 直接在前端保存（不安全，仅在无服务端情况下使用）
    accessKey: '2IxchoM0IYtnXekRNZAgG5CQtxzJjKyrPNbzBUMo',
    secretKey: 'rN1RVTzcGJuxuyKLTzhw4xfuiGwSdiBq8IXBEB8J',
    // Bucket 名称（仅用于展示/日志，可不填）
    bucket: 'china-sport',
    // token 有效期（秒）
    tokenExpireSeconds: 3600,
    // 空间访问控制
    access: 'public'
  }
}